// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"film-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M7 3L7 21H17L17 3L7 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7 3V21M17 3V21M3 7H7M3 17H7M21 7H17M21 17H17M3 12H21M3 21V3H21V21H3Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-film-1')
export default class Film1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'film-1',
    }
  }
}
